export default __webpack_public_path__ + "static/grafiek-7d9261c7aade70242f8e8e7ac28601e8.gif";